import { Outlet } from 'react-router-dom';

const BetweenAccounts = () => {
  return (
    <section className={'page-container'}>
      <div className={'content-wrapper'}>
        <Outlet />
      </div>
    </section>
  );
};

export default BetweenAccounts;
